<template>
  <div class="search-rides container-fluid r-aside">
    <head>
      <title>Wingz Support | Ride Search</title>
    </head>
    <loading :active.sync="isLoading" :can-cancel="true"> </loading>
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor">{{ title }}</h3>
      </div>
      <div class="col-md-7 align-self-center">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
          <li class="breadcrumb-item active">{{ title }}</li>
        </ol>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <form v-on:submit.prevent class="form-material">
              <div class="row">
                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-3">
                    <label class="search-label">Ride ID</label>
                    <input
                      v-model="id_ride"
                      class="form-control form-control-sm"
                      placeholder="Ride ID"
                      style="width: 100%"
                      type="text"
                      name="search_ride_search[ride_id]"
                      id="search_ride_search_ride_id"
                    />
                  </div>
                </div>
                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-3">
                    <label class="search-label">Leg ID</label>
                    <input
                      v-model="id_alternate"
                      class="form-control form-control-sm"
                      placeholder="Leg ID"
                      style="width: 100%"
                      type="text"
                      name="search_ride_search[triplegid]"
                      id="search_ride_search_tripleg_id"
                    />
                  </div>
                </div>
                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-3">
                    <label class="search-label">Trip ID</label>
                    <input
                      v-model="id_group_ride"
                      class="form-control form-control-sm"
                      placeholder="Trip ID"
                      style="width: 100%"
                      type="text"
                      name=""
                      id="search_ride_id_group_ride"
                    />
                  </div>
                </div>
                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-3 form-ddown">
                    <label class="search-label">Beginning Date</label>
                    <datetime
                      type="datetime"
                      v-model="min_date"
                      input-class="form-control form-control-sm"
                      placeholder="Min Departure Date"
                      label="Min Departure Date"
                      :noClearButton="false"
                    >
                    </datetime>
                    <font-awesome-icon
                      v-if="min_date"
                      @click="clearDate('min_date')"
                      icon="times"
                      style="color: red; cursor: pointer"
                    />
                  </div>
                </div>
                <div class="col-md-4 col-lg-4 p-0">
                  <div class="m-3 form-ddown">
                    <label class="search-label">Maximum Date</label>
                    <datetime
                      type="datetime"
                      v-model="max_date"
                      label="Max Departure Date"
                      input-class="form-control form-control-sm"
                      placeholder="Max Departure Date"
                    >
                    </datetime>
                    <font-awesome-icon
                      v-if="max_date"
                      @click="clearDate('max_date')"
                      icon="times"
                      style="color: red; cursor: pointer"
                    />
                  </div>
                </div>
                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-3">
                    <label class="search-label">Driver First Name</label>
                    <input
                      v-model="driver_name_first"
                      class="form-control form-control-sm"
                      placeholder="Driver First Name"
                      style="width: 100%"
                      type="text"
                      name="search_ride_search[driver_firstname]"
                      id="search_ride_search_driver_firstname"
                    />
                  </div>
                </div>
                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-3">
                    <label class="search-label">Driver Last Name</label>
                    <input
                      v-model="driver_name_last"
                      class="form-control form-control-sm"
                      placeholder="Driver Last Name"
                      style="width: 100%"
                      type="text"
                      name="search_ride_search[driver_lastname]"
                      id="search_ride_search_driver_lastname"
                    />
                  </div>
                </div>
                <!--<div class="col-md-2 col-lg-2 m-0 p-0">-->
                <!--&lt;!&ndash;<input class="form-control form-control-sm" placeholder="Partner Ride ID" style="width:100%" type="text"&ndash;&gt;-->
                <!--&lt;!&ndash;name="search_ride_search[partner_ride_id]" id="search_ride_search_partner_ride_id">&ndash;&gt;-->
                <!--</div>-->
                <!--                    <div class="col-md-2 col-lg-2 p-0">-->
                <!--                      <div class="m-3">-->
                <!--                        <label class="search-label">Rider Email</label>-->
                <!--                        <input v-model="rider_email" class="form-control form-control-sm" placeholder="Rider Email" style="width:100%" type="text"-->
                <!--                              name="search_ride_search[rider_email]" id="search_ride_search_rider_email">-->
                <!--                      </div>-->
                <!--                    </div>-->
                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-3">
                    <label class="search-label">Rider First Name</label>
                    <input
                      v-model="rider_name_first"
                      class="form-control form-control-sm"
                      placeholder="Rider First Name"
                      style="width: 100%"
                      type="text"
                      name="search_ride_search[rider_firstname]"
                      id="search_ride_search_rider_firstname"
                    />
                  </div>
                </div>
                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-3">
                    <label class="search-label">Rider Last Name</label>
                    <input
                      v-model="rider_name_last"
                      class="form-control form-control-sm"
                      placeholder="Rider Last Name"
                      style="width: 100%"
                      type="text"
                      name="search_ride_search[rider_lastname]"
                      id="search_ride_search_rider_lastname"
                    />
                  </div>
                </div>

                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-3">
                    <label class="search-label">From</label>
                    <input
                      v-model="default_pickup_address"
                      class="form-control form-control-sm"
                      placeholder="From"
                      style="width: 100%"
                      type="text"
                    />
                  </div>
                </div>
                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-3">
                    <label class="search-label">To</label>
                    <input
                      v-model="default_dropoff_address"
                      class="form-control form-control-sm"
                      placeholder="To"
                      style="width: 100%"
                      type="text"
                    />
                  </div>
                </div>

                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-3">
                    <label class="search-label">Select a Status</label>
                    <select
                      type="text"
                      placeholder="Status"
                      class="form-control ddown"
                      id="status-filter"
                      v-model="selected_status"
                    >
                      <option v-bind:value="null">All</option>
                      <option
                        v-for="(index, item) in data.filters.status"
                        v-bind:value="index"
                      >
                        {{
                          item
                            .replace(
                              item.charAt(0),
                              item.charAt(0).toUpperCase()
                            )
                            .replace("_", " ")
                            .replace("_", " ")
                            .replace("linear", "General")
                            .replace("logarithmic", "Accelerated")
                        }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-3">
                    <label class="search-label">Market</label>
                    <select
                      type="text"
                      placeholder="Market"
                      class="form-control ddown"
                      id="market-filter"
                      v-model="selected_market"
                    >
                      <option
                        v-for="market in markets"
                        v-bind:value="market.id_market"
                      >
                        {{ market.name }}
                      </option>
                      <option v-bind:value="'All'">All</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-3">
                    <label class="search-label">Ride Type</label>
                    <select
                      type="text"
                      placeholder="Ride Type"
                      class="form-control ddown"
                      id="ride-type-filter"
                      v-model="selected_ride_type"
                    >
                      <option v-bind:value="0">Regular</option>
                      <option v-bind:value="1">Deadhead</option>
                      <option v-bind:value="'All'">All</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-3">
                    <label class="search-label">Booking Mode</label>
                    <select
                      type="text"
                      placeholder="Booking Mode"
                      class="form-control ddown"
                      id="booking-mode-filter"
                      v-model="selected_booking_mode"
                    >
                      <option v-bind:value="'All'">All</option>
                      <option v-bind:value="'S'">Standing Order</option>
                      <option v-bind:value="'D'">Demand</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-4 col-lg-4 p-0">
                  <div class="m-3">
                    <label class="search-label">Select Vehicle Type</label>
                    <!-- <multiselect placeholder="Select vehicle type" :max-width="90"  v-model="selectedVehicleType" :options="vehicleOptions" label="name" track-by="name" :multiple="true" :taggable="true" @tag="addTag"></multiselect> -->
                    <div class="checkbox-item checkbox-form">
                      <ul class="checkbox-list">
                        <li
                          v-for="(options, index) in vehicleOptions"
                          :key="index"
                        >
                          <input
                            type="checkbox"
                            name="check"
                            :id="index"
                            :value="options.name"
                            v-model="selectedVehicleType"
                          />
                          <label :for="index">{{ options.name }}</label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-2">
                    <input
                      type="checkbox"
                      v-model="filter_duplicates"
                      id="filter_duplicates_checkbox"
                    />
                    <label class="search-label" for="filter_duplicates_checkbox"
                      >Only include duplicates</label
                    >
                  </div>
                </div>

                <div class="col-12 m-3 p-0 submit-button">
                  <button
                    v-on:click="buttonSearch(currentPage)"
                    class="btn btn-info waves-effect waves-light m-t-10"
                  >
                    Search
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="result">
              <div class="table-responsive">
                <table class="table table-hover table-sm" data-sort-name="Date">
                  <thead>
                    <tr>
                      <th>Page Size</th>
                      <th>
                        <select
                          v-model="perPage"
                          class="form-control table-select"
                          @change="checkPageSize($event)"
                        >
                          <option
                            v-for="size in page_sizes"
                            v-bind:key="size"
                            v-bind:value="size"
                          >
                            {{ size }}
                          </option>
                        </select>
                      </th>
                    </tr>

                    <tr style="cursor: pointer">
                      <th class="result-label" width="8%">
                        <div class="" @click="sort('id_ride')">
                          Ride ID
                          <div
                            class="arrow-down"
                            ref="id_ride"
                            :name="'id_ride'"
                            :value="1"
                            style="visibility: hidden; margin-left: 5px"
                          ></div>
                        </div>
                      </th>
                      <th class="result-label" width="8%">
                        <div class="" @click="sort('id_alternate')">
                          Leg ID
                          <div
                            class="arrow-down"
                            ref="id_alternate"
                            :name="'id_alternate'"
                            :value="1"
                            style="visibility: hidden; margin-left: 5px"
                          ></div>
                        </div>
                      </th>
                      <th class="result-label" width="8%">
                        <div class="">
                          Trip ID
                          <div
                            class="arrow-down"
                            ref="id_alternate"
                            :name="'id_group_ride'"
                            :value="1"
                            style="visibility: hidden; margin-left: 5px"
                          ></div>
                        </div>
                      </th>
                      <th class="result-label" width="3%">
                        <div>Ride Type</div>
                      </th>
                      <th class="result-label" width="3%">
                        <div>Ride Status</div>
                      </th>
                      <th class="result-label" width="3%">
                        <div>Claims Status</div>
                      </th>
                      <th class="result-label" width="8%">
                        <div class="" @click="sort('id_rider')">
                          Rider
                          <div
                            class="arrow-down"
                            ref="id_rider"
                            :name="'id_rider'"
                            :value="1"
                            style="visibility: hidden; margin-left: 5px"
                          ></div>
                        </div>
                      </th>
                      <th class="result-label" width="8%">
                        <div class="" @click="sort('id_driver')">
                          Driver
                          <div
                            class="arrow-down"
                            ref="id_driver"
                            :name="'id_driver'"
                            :value="1"
                            style="visibility: hidden; margin-left: 5px"
                          ></div>
                        </div>
                      </th>
                      <th class="result-label" width="3%">
                        <div class="" @click="sort('date_pickup')">
                          Pick-up Date
                          <div
                            class="arrow-down"
                            ref="date_pickup"
                            :name="'date_pickup'"
                            :value="1"
                            style="visibility: hidden; margin-left: 5px"
                          ></div>
                        </div>
                      </th>
                      <th class="result-label" width="8%">Market</th>
                      <th class="result-label" width="10%">From</th>
                      <th class="result-label" width="10%">To</th>
                    </tr>
                  </thead>
                  <tbody class="col-12" style="word-break: break-all">
                    <tr
                      v-for="ride in data.sortedRides"
                      v-bind:key="ride.id_ride"
                      v-bind:class="
                        ride.id_multiload ? 'duplicate_ride_highlight' : ''
                      "
                    >
                      <td class="result-item nowrap">
                        <router-link :to="'/rides/' + ride.id_ride + '/'">
                          <!--<router-link :to="{name: 'Rides', params: {id_ride: ride.id_ride}}">-->
                          {{ ride.id_ride }}
                        </router-link>
                      </td>
                      <td class="result-item nowrap">
                        <router-link
                          v-if="ride.id_alternate"
                          :to="'/rides/' + ride.id_ride + '/'"
                        >
                          <!--<router-link :to="{name: 'Rides', params: {id_ride: ride.id_ride}}">-->
                          {{ ride.id_alternate }}
                        </router-link>
                        <div v-if="!ride.id_alternate">N/A</div>
                      </td>
                      <td class="result-item nowrap">
                        <router-link
                          :to="
                            '/search-rides/?id_group_ride=' + ride.id_group_ride
                          "
                          v-if="ride.id_group_ride"
                          style="padding: 0.3rem"
                          target="_blank"
                        >
                          {{ ride.id_group_ride }}
                        </router-link>

                        <component v-if="!ride.id_group_ride">{{
                          "N/A"
                        }}</component>
                      </td>
                      <td class="result-item nowrap">
                        {{
                          ride.deadhead && ride.deadhead == 1
                            ? "Deadhead"
                            : "Regular"
                        }}
                      </td>
                      <td class="result-item nowrap">
                        {{
                          ride.id_type_ride_status &&
                          ride.id_type_ride_status.name
                            ? ride.id_type_ride_status.name
                            : ride.id_type_ride_status &&
                              ride.id_type_ride_status.code
                            ? ride.id_type_ride_status.code
                            : ""
                        }}
                      </td>
                      <td class="result-item nowrap">
                        {{ ride.claim.name ? ride.claim.name : "N/A" }}
                      </td>
                      <td class="result-item nowrap">
                        <router-link
                          v-if="ride.id_rider"
                          :to="'/users/' + ride.id_rider.id_user + '/'"
                        >
                          {{
                            (ride.contact_first_name
                              ? ride.contact_first_name
                              : ride.id_rider.name_first) +
                            " " +
                            (ride.contact_last_name
                              ? ride.contact_last_name
                              : ride.id_rider.name_last)
                          }}
                          <br />
                        </router-link>
                        <!--<span v-if="ride.id_rider" class="">{{ ride.id_rider.email }}</span>-->
                      </td>
                      <td class="result-item nowrap">
                        <router-link
                          v-if="ride.id_driver"
                          :to="'/drivers/' + ride.id_driver.id_user + '/'"
                        >
                          {{
                            ride.id_driver.name_first +
                            " " +
                            ride.id_driver.name_last
                          }}
                          <br />
                        </router-link>
                        <div v-if="!ride.id_driver">N/A</div>
                        <!--<span v-if="ride.id_driver" class="">{{ ride.id_driver.email }}</span>-->
                      </td>
                      <td class="result-item nowrap">
                        <span class="" v-if="ride.date_pickup">
                          <!--{{ moment(ride.date_pickup).format("YYYY-MM-DD HH:mm")  + " (" + moment.tz(moment.tz.guess()).format('z') + ")" }}-->
                          {{
                            !ride.date_pickup
                              ? "N/A"
                              : ride.local_timezone
                              ? moment
                                  .utc(ride.date_pickup)
                                  .tz(ride.local_timezone)
                                  .format("MMMM Do YYYY, h:mm:ss a (z)")
                              : moment
                                  .utc(ride.date_pickup)
                                  .format("MMMM Do YYYY, h:mm:ss a (z)")
                          }}
                        </span>
                      </td>
                      <td class="result-item">
                        <span class="">{{
                          ride.id_market ? ride.id_market.name : "N/A"
                        }}</span>
                      </td>
                      <td class="result-item">
                        <span class="">{{ ride.default_pickup_address }}</span>
                      </td>
                      <td class="result-item">
                        <span class="">{{ ride.default_dropoff_address }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div
                  style="
                    background-color: rgba(0, 0, 0, 0.05);
                    float: left;
                    width: 100%;
                  "
                >
                  <div style="margin: 1rem 1rem; float: left">
                    <span v-if="totalRows > 0"
                      >Showing {{ perPage * (currentPage - 1) + 1 }} to
                      {{
                        perPage * currentPage > totalRows
                          ? totalRows
                          : perPage * currentPage
                      }}
                      of {{ totalRows }} entries</span
                    >
                    <span v-else>Showing 0 entries</span>
                  </div>

                  <div style="margin: 0 1rem; float: right">
                    <b-pagination
                      style="margin: 0.5rem 0"
                      align="center"
                      :total-rows="totalRows"
                      v-model="currentPage"
                      :per-page="perPage"
                      :limit="limit"
                      @change="changePage"
                    >
                    </b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import Multiselect from "vue-multiselect";

export default {
  metaInfo: {
    title: "Wingz Support | Ride Search",
  },
  name: "SearchRides",
  data() {
    return {
      title: "Ride Search",
      page_sizes: [20, 50, 100, 500, 1000],
      data: {
        rides: [],
        sortDirection: 0,
        filteredRides: [],
        sortedRides: [],
        resultColumns: [
          ["Ride ID", "id_ride"],
          ["Leg ID", "id_alternate"],
          ["Ride Status", "id_type_ride_status"],
          ["Rider", "id_rider"],
          ["Driver", "id_driver"],
          ["Date", "date_reservation"],
          ["Market", "market"],
          ["From", ""],
          ["To", ""],
        ],
        filters: {
          status: {
            unassigned: 15,
            booked: 4,
            accepted: 7,
            "en-route": 10,
            "picked-up": 11,
            "dropped-off": 12,
            distributing_linear: 16,
            distributing_logarithmic: 17,
            expired: 18,
            canceled: 23,
            canceled_by_rider: 2,
            canceled_by_support: 3,
            rider_no_show: 8,
            driver_no_show: 9,
            paid_denied: 24,
            received_after_pickup: 25,
            cancellation_pending: 21,
            completed: 14,
          },
        },
      },
      selected_status: null,
      id_ride: null,
      id_group_ride_param: null,
      driver_email: null,
      selected_booking_mode: "All",
      driver_name_first: null,
      driver_name_last: null,
      rider_email: null,
      rider_name_first: null,
      rider_name_last: null,
      id_business_provider: null,
      id_alternate: null,
      id_group_ride: null,
      default_dropoff_address: null,
      default_pickup_address: null,
      min_date: null,
      max_date: null,
      isLoading: false,
      currentPage: 1,
      totalRows: 0,
      perPage: 20,
      limit: 10,
      prev_sort: null,
      selected_market: "All",
      selected_ride_type: "All",
      markets: null,
      filter_duplicates: false,
      vehicleOptions: [
        {
          name: "Ambulatory",
        },
        {
          name: "Wheelchair",
        },
      ],
      selectedVehicleType: [],
    };
  },
  components: {
    Loading,
    Multiselect,
  },
  methods: {
    // multiselect handler
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.options.push(tag);
      this.value.push(tag);
    },
    sort(field) {
      console.log(field);

      let obj = this.$refs[field];
      console.log(obj);
      if (this.prev_sort) {
        this.prev_sort.style.visibility = "hidden";
      }

      let value = obj.getAttribute("value");
      console.log(obj.getAttribute("name"));
      obj.setAttribute("value", -value);
      console.log(obj.getAttribute("value"));

      obj.style.visibility = "visible";
      obj.style.transform = "rotate(" + (value > 0 ? 0 : 1) * 180 + "deg)";

      this.prev_sort = obj;

      this.search();
    },
    clearDate(date) {
      if (date == "min_date") {
        this.min_date = null;
      }
      if (date == "max_date") {
        this.max_date = null;
      }
    },
    checkPageSize: function (event) {
      this.search();
    },
    search: function (page) {
      this.isLoading = true;

      let vehicleType = [];
      if (this.selectedVehicleType.length) {
        this.selectedVehicleType.forEach((element) => {
          vehicleType.push(element);
        });
      }

      this.$http
        .get(
          process.env.API_BASE_URL_CS +
            "rides/?" +
            (this.id_ride == null ? "" : "id_ride=" + this.id_ride) +
            (this.id_alternate == null
              ? ""
              : "&id_alternate=" + this.id_alternate) +
            (this.id_group_ride == null
              ? ""
              : "&id_group_ride=" + this.id_group_ride) +
            (this.selected_status == null
              ? ""
              : "&id_type_ride_status=" + this.selected_status) +
            (this.selected_market == null || this.selected_market == "All"
              ? ""
              : "&id_market=" + this.selected_market) +
            (this.selected_booking_mode == null ||
            this.selected_booking_mode == "All"
              ? ""
              : "&booking_mode=" + this.selected_booking_mode) +
            (this.driver_name_first == null ||
            this.driver_name_first.length == 0
              ? ""
              : "&id_driver__name_first__icontains=" + this.driver_name_first) +
            (this.driver_name_last == null || this.driver_name_last.length == 0
              ? ""
              : "&id_driver__name_last__icontains=" + this.driver_name_last) +
            (this.rider_email == null || this.rider_email.length == 0
              ? ""
              : "&contact_email__icontains=" + this.rider_email) +
            (this.rider_name_first == null || this.rider_name_first.length == 0
              ? ""
              : "&contact_first_name__icontains=" + this.rider_name_first) +
            (this.rider_name_last == null || this.rider_name_last.length == 0
              ? ""
              : "&contact_last_name__icontains=" + this.rider_name_last) +
            (this.min_date == null
              ? ""
              : "&date_pickup__gte=" + this.min_date) +
            (this.max_date == null
              ? ""
              : "&date_pickup__lte=" + this.max_date) +
            (this.default_pickup_address == null ||
            this.default_pickup_address.length == 0
              ? ""
              : "&default_pickup_address__icontains=" +
                this.default_pickup_address) +
            (this.default_dropoff_address == null ||
            this.default_dropoff_address.length == 0
              ? ""
              : "&default_dropoff_address__icontains=" +
                this.default_dropoff_address) +
            (this.selected_ride_type == null || this.selected_ride_type == "All"
              ? ""
              : "&deadhead=" + this.selected_ride_type) +
            (this.filter_duplicates == null || !this.filter_duplicates
              ? ""
              : "&id_multiload__isnull=false") +
            "&vehicle_type=" +
            (vehicleType ? vehicleType : "") +
            "&ordering=" +
            (this.prev_sort
              ? (this.prev_sort.getAttribute("value") > 0 ? "" : "-") +
                this.prev_sort.getAttribute("name")
              : "") +
            "&page=" +
            (page ? page : this.currentPage) +
            "&page_size=" +
            this.perPage
        )
        .then((response) => {
          this.data.rides = response.data.results;
          this.data.filteredRides = this.data.rides.slice(0);
          this.data.sortedRides = this.data.rides.slice(0);

          if (response.data && response.data.count) {
            this.totalRows = response.data.count;
          }
        })
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.isLoading = false));
    },
    getMarkets: function () {
      this.isLoading = true;
      this.$http
        .get(process.env.API_BASE_URL_CS + "markets/")
        .then((response) => {
          console.log("markets response", response.data);
          this.markets = response.data;
        })
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          Vue.toasted.show("Something went wrong!", {
            theme: "bubble",
            position: "top-right",
            duration: 2000,
          });
          console.log(error.response);
          this.errors = error.response.data;
          this.non_field_errors = error.response.data.non_field_errors;
        });
    },
    buttonSearch(page) {
      this.resetPager();
      this.search(page);
    },
    changePage: function (page) {
      this.search(page);
    },
    resetPager: function () {
      this.currentPage = 1;
      this.totalRows = 0;
    },
  },
  mounted() {
    console.warn(this.$route.query.id_group_ride);
    if (this.$route.query.id_group_ride) {
      this.id_group_ride = this.$route.query.id_group_ride;
    }

    this.search();
    this.getMarkets();
  },
  created() {
    // document.title = "Wingz Support | Ride Search";
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.submit-button {
  margin-top: 10px;
}

.result {
  margin-top: 20px;
}

.table td {
  vertical-align: middle;
}
.table th > div {
  position: relative;
  display: inline;
}
.table th > div .arrow-down {
  position: absolute;
  right: -13px;
  top: 40%;
}
tr.duplicate_ride_highlight {
  background-color: #d87a7a5e;
}
</style>
<style>
.multiselect__tags {
  min-height: 40px !important;
  display: block !important;
  padding: 8px 40px 0 8px !important;
  border-radius: 0px;
  border: 0 !important;
  border-bottom: 1px solid #e8e8e8 !important;
  background: #fff !important;
  font-size: 12px !important;
  margin-top: -11px !important;
}

.multiselect__option {
  font-size: 0.875rem;
}
.multiselect__input {
  font-size: 0.875rem;
}
.multiselect__placeholder {
  font-size: 0.875rem;
}
</style>
<style scoped>
.checkbox-wrapper {
  max-width: 485px;
  width: 100%;
  margin: 0 auto;
  margin-top: 100px;
  background-color: #fff;
}
.checkbox-wrap {
  padding: 50px;
}
.filter-head {
  margin-bottom: 20px;
}
.filter-txt {
  display: block;
  color: #4d4d4d;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 12px;
}
.discoverred-txt {
  color: #a3a3a3;
  font-size: 16px;
}
.checkbox-item {
}
.checkbox-list {
  display: inline-flex;
  flex-wrap: wrap;
}
.checkbox-list li {
}

/*Checkboxes styles*/
.checkbox-list input[type="checkbox"] {
  display: none;
}

.checkbox-list input[type="checkbox"] + label {
  display: inline-flex;
  align-items: center;
  position: relative;
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: 600;
  color: #808080;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  margin-bottom: 12px;
  margin-right: 15px;
  height: 36px;
  border: 1px solid #e5e5e5;
  padding: 5px 10px;
  border-radius: 12px;
}
.checkbox-list input[type="checkbox"] + label:before {
  content: "";
  display: block;
  height: 15px;
  border: 2px solid #06f;
  display: none;
  width: 8px;
  margin-right: 20px;
  transform: rotate(45deg);
  border-top-color: transparent;
  border-left-color: transparent;
  transition: all 0.12s;
  position: static;
  margin-top: -2px;
}

.checkbox-list input[type="checkbox"]:checked + label {
  color: #06f;
  border-color: #06f;
}
.checkbox-list input[type="checkbox"]:checked + label:before {
  opacity: 1;
  display: inline-block;
}
.checkbox-list li.select-all {
  border: none;
  padding: 0;
  width: 100%;
}
.checkbox-list .select-all label {
  background-color: #f1f1f1;
  padding: 10px 18px;
  border-radius: 6px;
  border: none;
}
li {
  list-style: none;
}
.checkbox-item * {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}
.checkbox-item * {
  margin: 0;
  padding: 0;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/components/SearchRides.vue